import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import Select from "react-select";
import InputField from "../../utils/InputField";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import ConfirmPasswordFields from "../../utils/ConfirmPasswordFields";
import StaticFunctions from "../../utils/StaticFunctions";
import CheckBoxField from "../../utils/CheckBoxField";
import InputDatePicker from "../../utils/InputDatePicker";

class UserAddContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    static defaultProps = {
        rights: ['login'],
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.initValidUntil = new Date();
        this.initValidUntil.setFullYear(this.initValidUntil.getFullYear() + 1);

        this.requierdFields = ['email', 'firstName', 'lastName', 'companyId', 'language', 'password', 'confirmPassword'];

        this.state = {
            securityLevel: null,
            companies: [],
            inputError: [],
            inputParams: {
                email: '',
                firstName: '',
                lastName: '',
                companyId: this.props.baseData.companies.currentCompany.id,
                language: this.props.baseData.userData.language,
                dateValidUntil: this.initValidUntil,
                loginType: 'password',
                loginString: '',
                rights: ['login'],
            }
        };

        this.translate = this.props.baseData.translate;

        this.requestCompaniesForUser = this.requestCompaniesForUser.bind(this);
        this.addNewUser = this.addNewUser.bind(this);
        this.getInput = this.getInput.bind(this);
        this.setValidUntil = this.setValidUntil.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
        this.checkCompanyId = this.checkCompanyId.bind(this);
        this.validateEmail = this.validateEmail.bind(this);

    }

    componentWillMount() {

        this.requestCompaniesForUser();

    }

    requestCompaniesForUser() {

        const params = {
            action: 'getCompaniesForUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.props.baseData.companies.currentCompany.id,
            userId: this.props.baseData.userData.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    companies: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    requestCheckUserEmail(email) {

        if (!email) return null;

        const params = {
            action: 'checkUserMailNotExists',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            email: email
        };

        const callback = function(res) {
            if (res === true) {
                this.removeInputError('email');
            } else {
                this.addInputError('email');
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    enterAddUserDetails(event) {

        if (event.keyCode === 13) {
            this.addNewUser();
        } else if (event.keyCode === 27) {
            this.changeView();
        }

    }

    addNewUser() {

        const inputParams = this.state.inputParams;
        const securityLevel = (this.state.inputParams.loginType === 'password') ? StaticFunctions.getSecurityLevelOfPassword(this.state.inputParams.loginString) : 4;
        const isCompanyId = this.checkCompanyId(this.state.inputParams.companyId);
        const errorFields = this.validateInputFields();
        const params = {
            action: 'addNewUser',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            email: this.state.inputParams.email,
            firstName: this.state.inputParams.firstName,
            lastName: this.state.inputParams.lastName,
            companyId: parseInt(this.state.inputParams.companyId),
            language: this.state.inputParams.language,
            dateValidUntil: (this.state.inputParams.dateValidUntil) ? this.state.inputParams.dateValidUntil.getTime() : this.initValidUntil,
            loginType: this.state.inputParams.loginType,
            loginString: this.state.inputParams.loginString,
            rights: this.state.inputParams.rights
        };

        const callback = function (res) {
            if (res.success) {
                alert(this.translate(res.msgKey));

                this.props.changeView();
            } else {
                this.setInputError(res.errors);
            }
        }.bind(this);

        if (this.state.inputParams.email && this.state.inputParams.firstName && this.state.inputParams.lastName && isCompanyId && securityLevel >= 3) {
            this.api.request('AdminFunctions', params, callback, null);
        } else {
            this.setInputError(errorFields);

            alert(this.translate('errorOccured'));
        }

    }

    changeView() {

        if (this.props.changeView) this.props.changeView();

    }

    setInputError(errorFields) {

        this.setState({
            inputError: errorFields,
        });

    }

    addInputError(errorField) {

        if (!errorField) return null;

        const inputError = [...this.state.inputError];

        inputError.push(errorField);

        this.setState({
            inputError
        });

    }

    removeInputError(errorField) {

        const inputError = this.state.inputError.filter(
            (name) => {
                return (name !== errorField);
            }
        );

        this.setState({
            inputError
        });

    }

    resetInputError() {

        this.setState({
            inputError: [],
        });

    }

    getInput(event, name, value, isValid) {

        const inputParams = {...this.state.inputParams};

        if (name === 'email') {
            this.requestCheckUserEmail(value);

            inputParams[name] = value;
        } else if (name === 'password') {
            inputParams['loginType'] = 'password';
            inputParams['loginString'] = (isValid) ? value : '';
        } else if (name === 'token') {
            inputParams['loginType'] = 'token';
            inputParams['loginString'] = (isValid) ? value : '';
        } else {
            inputParams[name] = (isValid) ? value : '';
        }

        this.setState({inputParams});

    }

    setValidUntil(date) {

        this.getInput(null, 'dateValidUntil', date, true);

    }

    editSelect(event, key) {

        const newInput = {...this.state.inputParams};

        newInput[key] = event.value;

        this.setState({
            inputParams: newInput
        });

    }

    toggleCheckBox(fieldName, isChecked) {

        const newInput = {...this.state.inputParams};

        if (isChecked) {
            newInput.rights.push(fieldName);
        } else {
            newInput.rights = newInput.rights.filter((right) => right !== fieldName);
        }

        this.setState({
            inputParams: newInput
        });

    }

    validateInputFields() {

        const inputParams = {...this.state.inputParams};
        const errorFields = [];

        this.requierdFields.forEach((fieldName) => {
            const value = inputParams[fieldName];

            if (inputParams.hasOwnProperty(fieldName)) {
                if (fieldName === 'email') {
                    if (!this.validateEmail(value)) {
                        errorFields.push(fieldName);
                    }
                } else {
                    if (!value && value !== 0) {
                        errorFields.push(fieldName);
                    }
                }
            } else if (fieldName === 'loginString') {
                if (inputParams.loginType === 'password' && !inputParams.loginString) {
                    errorFields.push('password');
                    errorFields.push('confirmPassword');
                }
            } else {
                errorFields.push(fieldName);
            }
        });

        this.setState({
            inputError: errorFields
        });

        return errorFields;

    }

    checkInputError(fieldName) {

        const errorList = this.state.inputError;

        let result = 'ok';

        if (errorList) {
            if (errorList.indexOf(fieldName) >= 0) result = 'error';
        }

        return result;

    }

    checkCompanyId(companyId) {

        const companyIdInt = parseInt(companyId);
        const companies = this.state.companies;
        const companyIds = [];

        companies.map(
            (company) => {
                companyIds.push(parseInt(company.value));
            }
        );

        return (companyIds.includes(companyIdInt));

    }

    validateEmail(value) {

        if (value === '') return false;

        const isEmail = StaticFunctions.validateEmail(value);
        //const emailNotExits = this.requestCheckUserEmail(value);

        return (isEmail/* && emailNotExits*/);

    }

    renderRights() {

        const rights = this.props.rights;
        const doNotShow = ['superadmin', 'ps_login', 'ps_puncher', 'designshop_login', 'designshop_vendor'];
        const userRights = (this.state.inputParams) ? this.state.inputParams.rights : [];

        if (!this.props.baseData.checkUserRole('superadmin')) doNotShow.push('translations');

        return rights.map(
            (right, index) => {
                if (!doNotShow.includes(right.value)) {
                    return (
                        <CheckBoxField
                            key={'right-' + index}
                            name={right.value}
                            label={right.label}
                            isChecked={(right.init || userRights.includes(right.value))}
                            onChange={this.toggleCheckBox}
                        />
                    );
                }
            }
        );

    }

    render() {

        if (!this.state.inputParams) return <LoadingSplash color={'dark'}/>;

        const companies = this.state.companies;
        const languages = (this.props.baseData.languages) ? this.props.baseData.languages.languages : [];
        const rightsBlock = this.renderRights();
        const disabledCompanySelection = (companies.length === 1);
        const disabledLanguageSelection = (languages.length === 1);

        return (
            <div className="formSettings">
                <div>
                    <nav>
                        <h1>{this.translate('addNewUser')}</h1>
                    </nav>

                    <div className="col-lg-4">
                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('email')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="email"
                                                type="email"
                                                className={this.checkInputError('email')}
                                                value={this.state.inputParams.email}
                                                isRequired={true}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('firstLastName')}</td>

                                        <td className="text-left">
                                            <InputField
                                                name="firstName"
                                                className={this.checkInputError('firstName')}
                                                value={this.state.inputParams.firstName}
                                                isRequired={true}
                                                style={{marginRight: 8, width: 126}}
                                                onBlur={this.getInput}
                                            />

                                            <InputField
                                                name="lastName"
                                                className={this.checkInputError('lastName')}
                                                value={this.state.inputParams.lastName}
                                                isRequired={true}
                                                style={{width: 126}}
                                                onBlur={this.getInput}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('company')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="companyId"
                                                className={['chosen-container', 'chosen-container-single', this.checkInputError('companyId')].join(' ').trim()}
                                                style={{width: '260px'}}
                                                options={companies}
                                                value={companies.find(o => String(o.value) === String(this.state.inputParams.companyId)) || null}
                                                placeholder={this.translate('select') + '...'}
                                                clearable={false}
                                                noResultsText={this.translate('noResultsFound')}
                                                disabled={disabledCompanySelection}
                                                onChange={(event) => this.editSelect(event, 'companyId')}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('language')}</td>

                                        <td className="text-left">
                                            <Select
                                                name="language"
                                                className={['chosen-container', 'chosen-container-single', this.checkInputError('language')].join(' ').trim()}
                                                style={{width: '260px'}}
                                                options={languages}
                                                value={languages.find(o => String(o.value) === String(this.state.inputParams.language)) || null}
                                                placeholder={this.translate('select') + '...'}
                                                clearable={false}
                                                noResultsText={this.translate('noResultsFound')}
                                                disabled={disabledLanguageSelection}
                                                onChange={(event) => this.editSelect(event, 'language')}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="text-left labelSpan">{this.translate('validUntil')}</td>

                                        <td className="text-left">
                                            <InputDatePicker
                                                name="dateValidUntil"
                                                value={this.state.inputParams.dateValidUntil}
                                                locale={this.props.baseData.userData.language}
                                                onChange={this.getInput}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div>
                            <div className="formBox">
                                <div className="formBoxHeader">
                                    {this.translate('rights')}
                                </div>

                                <div>
                                    {rightsBlock}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <nav>
                        <h1>{this.translate('password')}</h1>
                    </nav>

                    <div className="col-lg-4">
                        <ConfirmPasswordFields
                            label1={this.translate('password')}
                            label2={this.translate('confirmPassword')}
                            className1={this.checkInputError('password')}
                            className2={this.checkInputError('confirmPassword')}
                            onConfirm={this.getInput}
                        />

                        <div className="formRow">
                            <table>
                                <tbody>
                                    <tr>
                                        <td className="text-left labelSpan webElement">&nbsp;</td>

                                        <td className="text-left">
                                            <a className="formButton" onClick={() => this.changeView()}>
                                                {this.translate('cancel')}
                                            </a>

                                            <a className="formButton" onClick={() => this.addNewUser()} onKeyDown={(event) => this.enterAddUserDetails(event)}>
                                                {this.translate('save')}
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div>
                            <p>{this.translate('changePasswordNoteText')}</p>
                        </div>

                        <div>
                            <ul>
                                <li>{this.translate('changePasswordNote1')}</li>
                                <li>{this.translate('changePasswordNote2')}</li>
                                <li>{this.translate('changePasswordNote3')}</li>
                                <li>{this.translate('changePasswordNote4')}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

}

export default UserAddContainer;
